import React, { FC } from 'react';
import { useFormik } from 'formik';
import {
  convertFinancialAccountFieldsToInitial,
} from '../../constants/financial-account/financial-account-form';
import { FINANCIAL_ACCOUNT_INPUTS } from '../../constants/financial-account/financial-account-inputs';
import { useTranslation } from 'react-i18next';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { FormInput } from '../merchants/FormInput';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { IFinancialAccount } from '../../store/payments/payments-interfaces-helper';
import { usePaymentContext } from '../../store/payments/payments-context';
import { updateFinancialAccountData } from '../../store/payments/actions/financial-account';

interface Props {
  data: IFinancialAccount,
  onClose: () => void,
  onConfirm: () => void,
}

export const FinancialAccountModalForm: FC<Props> = (props) => {
  const { data, onClose, onConfirm } = props;
  const { t } = useTranslation();
  const { merchantState: { merchantsLists: lists }} = useMerchants();
  const { paymentContextState: { isUpdatingFinancialAccountDataLoading }, dispatch } = usePaymentContext();

  const formik = useFormik({
    initialValues: convertFinancialAccountFieldsToInitial(data),
    onSubmit: () => updateFinancialAccountData({ dispatch, formik, id: data?.id, onConfirm }),
  });

  const INPUTS = FINANCIAL_ACCOUNT_INPUTS({ lists, t });

  return (
    <form className="px-8 row" onSubmit={formik.handleSubmit}>
      {
        INPUTS.map(input => (
          <FormInput
            key={input.key}
            formik={formik}
            {...input}
          />
        ))
      }

      <div className="text-center mt-5">
        <ButtonComponent
          buttonName="Cancel"
          buttonType={BUTTON_TYPE.CANCELLED}
          additionalClass="btn-sm"
          onButtonClick={onClose}
        />
        <ButtonComponent
          buttonName="Confirm"
          type="submit"
          additionalClass="btn-sm ms-10 w-100px"
          loading={isUpdatingFinancialAccountDataLoading}
        />
      </div>
    </form>
  );
};